import { type Period } from 'apps/employer_renewals/types'
import { formatMoney } from 'utils'

type Props = {
  money: number
  period: Period
}

export default function BigMoney ({ money, period }: Props) {
  const formattedMoney = formatMoney(money)
  const dollarsAndCents = formattedMoney.split('.')
  const dollars = dollarsAndCents[0].replace('$', '')
  const cents = dollarsAndCents[1]

  return (
    <div className='flex flex-row'>
      <span className='body-sm-bold mt-1.5'>$</span>
      <span className='heading-xl px-0.5 break-all'>{dollars}</span>
      <span className='body-sm-bold mt-1.5'>.{cents}</span>
      {period === 'monthly' && <span className='body-sm text-gray-500 mt-1.5 ml-0.5'> / month</span>}
    </div>
  )
}
